module.exports = __webpack_public_path__ + "img/tier-bg.1ce85237.png";